
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","viewBox":"0 0 12 12"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#8d98aa","stroke-linecap":"round","stroke-linejoin":"round","data-name":"vuesax/twotone/document-copy"}},[_c('path',{attrs:{"d":"M8.794 6.746v1.661c0 2.212-.885 3.1-3.1 3.1H3.6c-2.215-.006-3.1-.891-3.1-3.1v-2.1c0-2.215.885-3.1 3.1-3.1h1.655","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M8.757 6.782h-1.77c-1.327 0-1.769-.439-1.769-1.77V3.243z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M3.265 2.159A1.647 1.647 0 014.904.5h3.279M11.5 3.786v3.422a1.555 1.555 0 01-1.554 1.554","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M11.5 3.817H9.842c-1.244 0-1.659-.417-1.659-1.658V.5z"}})])])
          )
        }
      }
    